import PhoneticText from "@/components/ui/phoneticText";
export default {
  components: {
    PhoneticText,
  },
  props: {
    // 资源json
    jsonData: {
      type: [Object, Array],
      default: null,
    },
    // 是否需要自定义提交数据接口
    isCustom: {
      type: Boolean,
      default: false,
    },
    // 是否需要显示解析
    isShowAnAnalysis: {
      type: Boolean,
      default: true,
    },
    //是否是教科书练习提交（默认false,默认是作业提交）
    isTextBook: {
      type: Boolean,
      default: false,
    },
    submit: {
      type: Function,
      default: () => {},
    },
    baseUrl: {
      type: String,
      default: "",
    },
    leaveCloseVideo: {
      type: Boolean,
      default: false,
    },
    ansProgressStatus: {
      type: Number,
      default: 0,
    },
    // 是否专项练习(可以理解为是否需要手动控制音频)
    isSpecial: {
      type: Boolean,
      default: false,
    },
    // 自定义题目序号
    serial: {
      type: [String, Number],
      default: "",
    },
    isSPC: {
      type: Boolean,
      required: false,
    },
    isExamMode: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      // 拼音组件样式
      baseStyles: {
        // 拼音文本字体大小
        pinyinFontSize: "14px",
        // 拼音文本 行高
        pinyinLineHeight: "14px",
        // 拼音文本字体大小
        hzFontSize: "16px",
        // 汉字文本 行高
        hzLineHeight: "26px",
        // 行文 间距(下方间距)
        writingSpacing: "10px",
        // 分词间隔
        wordSpacing: "10px",
      },
    };
  },
  filters: {
    localePartOfSpeech: function (item) {
      let language = localStorage.getItem("language");
      if (language === "zh") {
        language = "en";
      }

      return item[`part_of_speech_${language}`]
        ? item[`part_of_speech_${language}`]
        : item[`part_of_speech_en`]
        ? item[`part_of_speech_en`]
        : "";
    },
    // 文本翻译多语言
    localeTranslation: function (item) {
      let language = localStorage.getItem("language");
      if (language === "zh") {
        language = "en";
      }

      return item[`translation_${language}`]
        ? item[`translation_${language}`]
        : item[`translation_en`]
        ? item[`translation_en`]
        : "";
    },
  },
  watch: {},
  computed: {
    textStyles() {
      return function (screenTextItem) {
        return {
          // 拼音文本初始颜色
          originPinyinColor: "#3F4651",
          // 拼音文本字体大小
          pinyinFontSize: "14px",
          // 拼音文本 行高
          pinyinLineHeight: "14px",
          // 汉字文本初始颜色
          originHzColor: "#3E4651",
          // 拼音文本字体大小
          hzFontSize: "18px",
          // 汉字文本 行高
          hzLineHeight: "26px",
          // 行文 间距(下方间距)
          writingSpacing: "10px",
          // 分词间距
          wordSpacing: "10px",
          //文本类型的screenText，适配style样式
          hasIndent: screenTextItem && screenTextItem.style && screenTextItem.style.indent * 18 + 10 + "px",
        };
      };
    },
    smallTextStyles() {
      return {
        // 拼音文本初始颜色
        originPinyinColor: "#3F4651",
        // 拼音文本字体大小
        pinyinFontSize: "14px",
        // 拼音文本 行高
        pinyinLineHeight: "14px",
        // 汉字文本初始颜色
        originHzColor: "#3E4651",
        // 拼音文本字体大小
        hzFontSize: "16px",
        // 汉字文本 行高
        hzLineHeight: "24px",
        // 行文 间距(下方间距)
        writingSpacing: "10px",
        // 分词间距
        wordSpacing: "10px",
      };
    },
  },
  methods: {
    postAnswer(params, callback) {
      if (!this.isTextBook) {
        utilV2.postData(
          ApiPath.homework_topic_post_exercise_log,
          params,
          () => {
            callback();
          },
          (e) => {
            //提交数据失败
            this.restorePlay && this.restorePlay();
            layer.msg(e.errmsg);
          },
        );
      } else {
        this.submit(params, callback);
      }
    },
    // 播放原音
    // playAudio(src) {
    //   this.$player.play(src)
    // },
  },
  destroyed() {
    this.leaveCloseVideo && this.$player.stop();
  },
  deactivated() {
    this.leaveCloseVideo && this.$player.stop();
  },
};
